<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <span class="font-weight-bold feedback-rule-row" for="inputEmail">{{
          t('Country Rules')
        }}</span>
        <div class="form-check float-right">
          <toggle-button
            :sync="true"
            color="#2eb15a"
            :labels="true"
            v-model="showCountryFlag"
          />
        </div>
        <p v-if="!showCountryFlag">
          <small class="text-muted">
            {{ label }} to
            <b>every countries</b>
          </small>
        </p>
        <p v-if="showCountryFlag">
          <small class="text-muted">
            {{ label }}
            <span v-if="showCountries === 'every countries' && label !== 'track'">to</span>
            <span v-if="label === 'track'">visitors coming from</span>
            <span v-else>to visitors coming from</span>
            <b>{{ showCountries }}</b>
          </small>
        </p>
      </div>
    </div>
    <div
      v-if="showCountryFlag"
      style="
        background-color: rgb(243, 248, 255);
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 30px;
      "
    >
      <div v-if="showCountryFlag">
        <div class="row mt-1" v-if="showCountryFlag">
          <div class="col-md-4">
            <select v-model="countryCondition" class="custom-select">
              <option value="whitelist">Whitelist</option>
              <option value="blacklist">Blacklist</option>
            </select>
          </div>
          <div class="col-md-8 pl-0">
            <CountryDropdown @callback="readCountry"></CountryDropdown>
          </div>
        </div>
      </div>

      <div v-if="showCountryFlag" class="mt-2">
        <div
          v-for="(item, key) in countryRules"
          v-bind:key="key"
          class="row my-1 country-spacing"
          :id="'added-country-' + item.code"
        >
          <div
            class="selected-country-item col-md-12"
            :data-rule="item.rule"
            :data-name="item.name"
            :data-code="item.code"
            v-if="item.rule === 'whitelist'"
          >
            <img width="20" class="d-inline mr-2" src="../assets/img/yes.png" />
            {{ item.name }}
            <span class="float-right pt-1 cursor-pointer">
              <font-awesome-icon
                class="text-danger"
                icon="trash"
                @click="deleteRow(item.code)"
              />
            </span>
          </div>
        </div>

        <div
          v-for="(item, key) in countryRules"
          v-bind:key="key"
          class="row my-1 country-spacing"
          :id="'added-country-' + item.code"
        >
          <div
            class="selected-country-item col-md-12"
            :data-rule="item.rule"
            :data-name="item.name"
            :data-code="item.code"
            v-if="item.rule === 'blacklist'"
          >
            <img width="20" class="d-inline mr-2" src="../assets/img/no.png" />
            {{ item.name }}
            <span class="float-right pt-1 cursor-pointer">
              <font-awesome-icon
                class="text-danger"
                icon="trash"
                @click="deleteRow(item.code)"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryDropdown from '@/components/CountryDropdown.vue'

export default {
  components: {
    CountryDropdown,
  },
  props: ['data', 'label'],
  data: function () {
    return {
      showCountryFlag: false,
      countryRules: [],
      countryCondition: 'whitelist',
      selectedCountry: null,
      showCountries: 'every countries',
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.data) this.countryRules = JSON.parse(this.data)
      if (this.countryRules.length) this.showCountryFlag = true
      this.generateList()
    }, 400)
  },
  methods: {
    exist(x) {
      for (let i in this.countryRules) {
        if (this.countryRules[i].rule === x) return true
      }
      return false
    },
    generateList() {
      this.showCountries = 'every countries'
      let list = []
      for (let i in this.countryRules) {
        if (this.countryRules[i].rule === 'whitelist') {
          list.push(this.countryRules[i].name)
        }
      }

      if (list.length) this.showCountries = list.join(', ')

      if (!list.length) {
        for (let i in this.countryRules) {
          if (this.countryRules[i].rule === 'blacklist') {
            list.push(this.countryRules[i].name)
            this.showCountries = 'every countries except ' + list.join(', ')
          }
        }
      }

      this.showCountries = this.showCountries.replace(/,([^,]*)$/, ' and$1')
    },
    readCountry(data) {
      this.selectedCountry = data
      this.addRow()
    },
    deleteRow(code) {
      for (let i in this.countryRules) {
        if (this.countryRules[i].code === code) this.countryRules.splice(i, 1)
      }
      this.generateList()
    },
    addRow() {
      for (let i in this.countryRules) {
        if (this.countryRules[i].code === this.selectedCountry.code) return
      }
      this.countryRules.push({
        rule: this.countryCondition,
        name: this.selectedCountry.name,
        code: this.selectedCountry.code,
      })
      this.generateList()
    },
    random() {
      return Math.floor(Math.random() * 10000 + 1)
    },
  },
}
</script>

<style>
.selected-country-item {
  border-radius: 4px;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #ced4da;
}

.country-spacing {
  margin: 14px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AllowedCountryForm.vue